import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  switch(event) {
    const input = event.target
    if (input.type !== "radio" || !input.checked) return

    const switchees = document.querySelectorAll(`[id^="radios-switchee-${input.name}"]`)
    switchees.forEach((element) => element.classList.add("hidden"))

    const switchee = document.getElementById(`radios-switchee-${input.name}-${input.value}`)
    if (switchee) switchee.classList.remove("hidden")
  }
}
